// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"201":"e84dc9df","608":"7e4e8a42","925":"07d47e02","939":"4b5fba57"}[chunkId] + ".css";
};